<template>
	<div>
		<div class="pop_a" v-if="popStats.key == 1">
			<img src="/static/images/checked.png" alt="">
			<p>{{popStats.text}}</p>
		</div>
		<div class="pop_b" v-if="popStats.key == 2">
			<img src="/static/images/checked.png" alt="">
			<div class="popTxt">
				<p>有新的分享任务完成</p>
				<p>获得新贡献</p>
			</div>
			<p class="hrfe" @click="jump(popStats.text)">去看看>></p>
		</div>
	</div>
</template>

<script>
    export default {
        name: "index",
        props: {
            popStats: {
                type: Object,
                required: true
            }
        },
		data(){
            return{

			}
		},
		mounted() {

            // console.log(this.popStats,"????")
        },
		methods:{
            jump(e){
                window.location.href = e;
            }
		}
    }
</script>

<style scoped>
	.pop_a{
		width: 201px;
		height: 48px;
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		background: #f3f4f5;
		/*padding: 12px 15px;*/
		overflow: hidden;
		float: left;
		border-radius: 10px;
		justify-content: center;
	}
	.pop_a>img{
		width: 24px;
		height: 24px;
		margin-right: 10px;
	}
	.pop_a>p{
		font-size: 15px;
		color: #2f80ed;
	}
	.pop_b{
		width: 161px;
		border-radius: 10px;
		background: #f3f4f5;
		overflow: hidden;
	}
	.pop_b>img{
		width: 24px;
		height: 24px;
		display: block;
		margin: 12px auto;
	}
	.popTxt{
		width: 131px;
		margin: 0 auto 10px;
		text-align: center;
		color: #2f80ed;
	}
	.hrfe{
		text-align: center;
		padding-bottom: 12px;
		font-size: 14px;
	}
</style>



// WEBPACK FOOTER //
// src/component/popUps/index.vue